module.exports = __webpack_public_path__ + "img/interestFollowUps.23ef1486.svg";